import documents from 'services/api/resources/documents';
import ogden from 'services/api/resources/ogden-tables';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'resources-and-tools';

/**
 * Calculator Resource Endpoints:
 *     - Date Calculators
 *     - Monetary Calculators
 */
export default {
    /**
     * Documents Endpoints.
     *
     * @type {}
     */
    documents,

    /**
     * Ogden Endpoints.
     *
     * @type {}
     */
    ogden,
};



// WEBPACK FOOTER //
// ./src/services/api/resources.js